// handle event for contract new
import { apiContract } from "../../../../api/api-contract";
import { alert } from "../../../../common/utils/alert";
import { emitter } from "../../../../common/utils/emitter";
import moment from "moment";
//1.submission

export const contractSubmit = (context) => {
  const customerInfoState = context.customerInfo.state;
  const vehicleInfoState = context.vehicleInfo.state;
  const carReturnBeforeState = context.carReturnBefore.state;
  context.form
    .validateFields()
    .then(async (values) => {
      context.setState({ disabledOk: true }, async () => {
        const { contract_code } = values;
        const { prefix_code, suffix_code } = contract_code;
        if (!prefix_code || !suffix_code) {
          return alert("error", "Mã hợp đồng là bắt buộc");
        }
        emitter.emit("FETCH_LOADING", true);
        // Xử lý các phần Fee mà không có trong Form

        let costs = [
          {
            code: "CT001",
            value: Number(values.CT001),
          },
          {
            code: "CT003",
            value: Number(values.CT003),
          },
          {
            code: "CT019",
            value: Number(values.CT019),
          },
        ];
        let norms = [
          {
            code: "OLQ001",
            value: Number(values.OLQ001),
          },
          {
            code: "OLQ005",
            value: Number(values.OLQ005),
          },
        ];

        // Lấy tất cả dữ liệu có trong Form + Các state trong component cần thiết + Convert các Range Date thành date
        let payload = {
          member_customer_id: customerInfoState.user
            ? customerInfoState.user.id
            : null,
          customer_id: customerInfoState.customer_info.customer_id,
          driver_id: vehicleInfoState.driver_info
            ? vehicleInfoState.driver_info.id
            : null,
          vehicle_id: vehicleInfoState.vehicle_info
            ? vehicleInfoState.vehicle_info.id
            : null,
          return_vehicle_early: carReturnBeforeState.return_vehicle_early,
          //lay tu state
          // lay tu form
          ...values,
          penalty_rate_early_termination: Number(
            values.penalty_rate_early_termination
          ),
          sign_date: values.sign_date.startOf("day").valueOf(),
          from_datetime: values.from_datetime.startOf("day").valueOf(),
          to_datetime: values.to_datetime.startOf("day").valueOf(),
          costs,
          norms,
          prefix_code,
          suffix_code,
        };
        try {
          let idEdit = null;
          let func = apiContract.createContractWithoutDriver;
          if (context.state.editPage) {
            if (context.state.unlimitEdit) {
              func = apiContract.editImmediateContractWithoutDriver;
            } else {
              func = apiContract.editEffectiveDateContractWithoutDriver;
              payload.effective_date = values.effective_date
                ? values.effective_date.startOf("day").valueOf()
                : null;
            }
            idEdit = context.contractParam.id;
          }
          if (
            context.state.editPage &&
            context.state.limitEdit &&
            context.state.unlimitEdit
          ) {
            scrollTopContract();
            alert("success", "Chỉnh sửa hợp đồng thành công");
            context.props.close();
            return;
          }
          const result = await func(payload, idEdit);
          emitter.emit("FETCH_LOADING", false);
          if (result.status === "success") {
            context.setState({ disabledOk: false });
            let new_suffix_code = Number(suffix_code) + 1;
            if (new_suffix_code < 10) {
              new_suffix_code = `00${new_suffix_code}`;
            } else if (new_suffix_code >= 10 && new_suffix_code < 100) {
              new_suffix_code = `0${new_suffix_code}`;
            }
            scrollTopContract();
            if (context.state.editPage) {
              alert("success", "Chỉnh sửa hợp đồng thành công");
              context.props.close();
            } else {
              context.successModal.changeVisible(
                true,
                `${prefix_code} - ${suffix_code}`,
                () =>
                  context.addVehicleInSuccess({
                    code: prefix_code,
                    suffix_code: new_suffix_code,
                  }),
                context.addNewContractSuccess,
                context.props.close
              );
            }
          } else {
            context.setState({ disabledOk: false });
            alert("error", result.data.message);
          }
        } catch (error) {
          context.setState({ disabledOk: false });
          emitter.emit("FETCH_LOADING", false);
          alert("error", "Network Error");
        }
      });
    })
    .catch((info) => {
      emitter.emit("FETCH_LOADING", false);
      scrollTopContract();
      // Khi xảy ra validation error thì scroll về đầu trang
    });
};

const scrollTopContract = () => {
  const element = document.getElementById("right-layout");
  element.scrollTo(0, 0);
};

export const convertContract = (contract, context, editPage) => {
  if (contract.contract_code) {
    context.contractCode.setState({
      ...contract.contract_code,
    });
  }
  // setState cho các component cần thay đổi state lúc mới vào và ko có trong Form
  context.customerInfo.setState({
    customer_info: contract.customer
      ? contract.customer
      : {
          company_name: "",
          id: -1,
          customer_id: -1,
          tax_code: "",
          customer_info: "",
        },
    isDisableUser: contract.customer ? false : true,
    user: contract.member_customer
      ? contract.member_customer
      : {
          phone_number: "",
          email: "",
        },
    optionsCompany: [],
    optionsUser: [],
  });
  if (editPage) {
    context.vehicleInfo.oldVehicle = contract.vehicle;
    context.vehicleInfo.oldDriver = contract.driver;
    context.vehicleInfo.setState({
      driver_know_english: contract.driver_know_english
        ? contract.driver_know_english
        : true,
      parking_id: contract.parking_id ? contract.parking_id : 1,
      optionsVehicle: contract.vehicle
        ? [{ ...contract.vehicle, value: contract.vehicle.number_plate }]
        : [],
      optionsDriver: contract.driver
        ? [
            {
              ...contract.driver,
              value: `${contract.driver.name} - ${contract.driver.mobile}`,
            },
          ]
        : [],
      vehicle_info: contract.vehicle
        ? contract.vehicle
        : {
            color: "",
            contract_contained: null,
            id: null,
            model: "",
            number_plate: "",
            type: "",
          },
      required: contract.vehicle ? true : false, // Khi edit page nếu có tài và xe rồi thì bắt buộc phải có
      driver_info: contract.driver
        ? contract.driver
        : {
            contract_contained: null,
            email: "",
            id: null,
            id_card: "",
            name: "",
            phone_number: "",
          },
    });
  } else {
    context.vehicleInfo.setState({
      optionsDriver: [],
      optionsVehicle: [],
      vehicle_info: {
        color: "",
        contract_contained: null,
        id: null,
        model: "",
        number_plate: "",
        type: "",
      },
      driver_info: {
        contract_contained: null,
        email: "",
        id: null,
        id_card: "",
        name: "",
        phone_number: "",
      },
    });
  }

  context.carReturnBefore.setState({
    return_vehicle_early:
      contract.return_vehicle_early !== undefined
        ? contract.return_vehicle_early
        : 1,
  });

  context.carReturnBefore.init_return_vehicle_early =
    contract.return_vehicle_early; // set vao init value de check khi change

  const { from_datetime, to_datetime, branch, costs, norms } = contract;
  // Lấy dữ liệu đổ vào Form gồm các Param được Form sử dụng để call api

  let dataForm = {
    CT001: 0,
    CT019: 0,
    CT003: 0,
    OLQ001: 0,
    OLQ005: 0,
    customer_info: contract.customer ? contract.customer.name : "",
    user: contract.member_customer ? contract.member_customer.name : "",
    vehicle_info: editPage
      ? contract.vehicle
        ? contract.vehicle.number_plate
        : ""
      : "",
    driver_info: editPage
      ? contract.driver
        ? `${contract.driver.name}`
        : ""
      : "",
    branch_code: branch ? branch.code : null,
    sign_date: contract.sign_date ? moment(contract.sign_date) : null,
    from_datetime: moment(from_datetime),
    to_datetime: moment(to_datetime),
    deposit: contract.deposit ? contract.deposit : 0,
    payment_term: contract.payment_term ? contract.payment_term : 0,
    days_inform_before_return_vehicle: contract.days_inform_before_return_vehicle
      ? contract.days_inform_before_return_vehicle
      : 0,
    penalty_rate_early_termination: contract.penalty_rate_early_termination
      ? Number(contract.penalty_rate_early_termination)
      : 0,
    note: contract.note ? contract.note : 0,
    fuel_type_code: contract.fuel_type ? contract.fuel_type.code : null,
    rental_service_type_code: contract.rental_service_type
      ? contract.rental_service_type.code
      : null,
    vehicle_working_area: contract.vehicle_working_area
      ? contract.vehicle_working_area
      : "",
    contract_code: contract.contract_code
      ? contract.contract_code
      : {
          prefix_code: "",
          suffix_code: "001",
        },
    days_inform_before_early_termination: contract.days_inform_before_early_termination
      ? contract.days_inform_before_early_termination
      : 0,
    fuel_adjust_percent: contract.fuel_adjust_percent
      ? contract.fuel_adjust_percent.toFixed(2)
      : 0,
  };

  costs &&
    costs.forEach((cost) => {
      switch (cost.code) {
        case "CT001":
          return (dataForm.CT001 = cost.value);
        case "CT003":
          return (dataForm.CT003 = cost.value);
        case "CT019":
          return (dataForm.CT019 = cost.value);
        default:
          return;
      }
    });

  norms &&
    norms.forEach((norm) => {
      switch (norm.code) {
        case "OLQ001":
          return (dataForm["OLQ001"] = norm.value);
        case "OLQ005":
          return (dataForm["OLQ005"] = norm.value.toFixed(1));
        default:
      }
    });
  context.form.setFieldsValue({ ...dataForm, effective_date: null });
  context.initFormValue = dataForm;
};

export const initValues = () => {
  return {
    vehicle_working_area: "",
    days_inform_before_early_termination: 0,
    CT001: 0,
    OLQ001: 0,
    OLQ005: 0,
    fuel_adjust_percent: 0,
    CT019: 0,
    CT003: 0,
    branch_code: "",
    sign_date: moment(),
    from_datetime: moment().add(1, "day"),
    to_datetime: moment().add(2, "day"),
    deposit: 0,
    payment_term: 0,
    working_day_value: "",
    days_inform_before_return_vehicle: 0,
    penalty_rate_early_termination: 0,
    note: "",
    contract_code: null,
  };
};

const checkSameValue = (context) => {
  const values = context.form.getFieldsValue();
  const initValues = context.initFormValue;
  let checkIndex = 0;
  const keys = Object.keys(values);
  keys.forEach((key) => {
    switch (key) {
      case "branch_code":
      case "vehicle_working_area":
      case "sign_date":
      case "vehicle_info":
      case "driver_info":
      case "days_inform_before_early_termination":
      case "penalty_rate_early_termination":
      case "deposit":
      case "payment_term":
      case "days_inform_before_return_vehicle":
      case "fuel_type_code":
      case "from_datetime":
      case "to_datetime":
      case "note":
        if (
          (!initValues[key] && values[key]) ||
          (initValues[key] &&
            JSON.stringify(initValues[key]) !== JSON.stringify(values[key]))
        ) {
          checkIndex = 1;
        }
        break;
      default:
        if (
          (!initValues[key] && values[key]) ||
          (initValues[key] &&
            JSON.stringify(initValues[key]) !== JSON.stringify(values[key]))
        ) {
          checkIndex = 2;
        }
        break;
    }
  });

  if (checkIndex === 1) {
    context.setState(
      {
        limitEdit: false,
        unlimitEdit: true,
      },
      () => context.form.validateFields(["effective_date"])
    );
  } else if (checkIndex === 2) {
    context.setState(
      {
        limitEdit: true,
        unlimitEdit: false,
      },
      () => context.form.validateFields(["effective_date"])
    );
  } else {
    const { init_return_vehicle_early } = context.carReturnBefore;
    const { return_vehicle_early } = context.carReturnBefore.state;
    if (return_vehicle_early !== init_return_vehicle_early) {
      return context.setState(
        {
          limitEdit: false,
          unlimitEdit: true,
        },
        () => context.form.validateFields(["effective_date"])
      );
    }
    context.setState(
      {
        limitEdit: true,
        unlimitEdit: true,
      },
      () => context.form.validateFields(["effective_date"])
    );

    //func && func();
    //, () => context.form.validateFields(['effective_date']) sẽ check cho trường effective_date khi đổi qua lại giữa các lần NGÀY HIỆU LỰC
  }
};

export const checkChangeFormValue = (context, func) => {
  checkSameValue(context, func);
};
